import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fbaFullType'
})
export class FullTypePipe implements PipeTransform {

  constructor (private translateService: TranslateService) {}

  transform (value: any): any {
    const translatedType = this.translateService.instant(`app-geo-dropdown.${value.type}`);
    const combinedType   = [translatedType, value.category];
    return combinedType.filter((name) => Boolean(name))
                       .join(' / ');
  }

}
